// import { Indicator } from 'mint-ui'
// import { serviceCheckNetwork } from './service'

export default [
    { path: '/signin', component: require('./views/Signin.vue') },
    { path: '/index', component: require('./views/Index.vue') },
    { path: '/quickadd', component: require('./views/quickAdd.vue') },
    /* 班级管理 */
    { path: '/class/edit/:classId', component: require('./views/class/ClassEdit.vue') },
    { path: '/class/add', component: require('./views/class/ClassAdd.vue') },
    /* 学生管理 */
    { path: '/student/manage', component: require('./views/student/StudentManage.vue') },
    { path: '/student/add', component: require('./views/student/StudentAdd.vue') },
    { path: '/student/out', component: require('./views/student/StudentOut.vue') },
    { path: '/student/edit/:studentId', component: require('./views/student/StudentEdit.vue') },
    { path: '/student/detail/:studentId', component: require('./views/student/StudentDetail.vue') },
    // 作业
    { path: '/homework/add', component: require('./views/homework/homeworkAdd.vue') },
    { path: '/homework/list', component: require('./views/homework/homeworkList.vue') },
    { path: '/homework/detail/:homeWorkId', component: require('./views/homework/homeworkDetail.vue') },
    { path: '/homework/student/list/:studentId/:studentName', component: require('./views/homework/homeworkStudent.vue') },
    /* 老师管理 */
    { path: '/teacher/manage', component: require('./views/teacher/TeacherManage.vue') },
    { path: '/teacher/detail/:teacherId', component: require('./views/teacher/TeacherDetail.vue') },
    /* 园点管理 */
    { path: '/curche/detail', component: require('./views/curche/CurcheDetail.vue') },
    { path: '/curche/edit', component: require('./views/curche/CurcheEdit.vue') },
    { path: '/contact/list', component: require('./views/contacts/contact.vue') },
    { path: '/contact/parent', component: require('./views/contacts/parent.vue') },
    /* 用户中心 */
    { path: '/user/center', component: require('./views/user/userCenter.vue') },
    { path: '/user/center/collectionList', component: require('./views/user/userCollection/CollectionList.vue') },
    { path: '/user/center/settings', component: require('./views/user/userCollection/Settings.vue') },
    { path: '/user/center/about', component: require('./views/user/userCollection/About.vue') },
    { path: '/user/center/updPhone', component: require('./views/user/userCollection/UpdatePhone.vue') },
    { path: '/user/center/AppShare', component: require('./views/user/AppShare.vue') },
    { path: '/user/center/hostcenterApply', component: require('./views/user/hostcenterApply.vue') },
    { path: '/user/center/hostTeacherRegister', component: require('./views/user/hostTeacherRegister.vue') },
    { path: '/user/center/NewsClass', component: require('./views/user/NewsClass.vue') },
    { path: '/user/center/NewsList/:type', component: require('./views/user/NewsList.vue') },
    { path: '/user/center/NewsDetail/:pushId', component: require('./views/user/NewsDetail.vue') },
    { path: '/user/center/NewsDetailInvitation/:pushId', component: require('./views/user/NewsDetailInvitation.vue') },
    /* 点名 */
    { path: '/rollcall/list', component: require('./views/rollcall/rollcallList.vue') },
    { path: '/rollcall/custom', component: require('./views/rollcall/rollcallCustom.vue') },
    { path: '/rollcall/edit/:rollcallId', component: require('./views/rollcall/rollcallEdit.vue') },
    { path: '/rollcall/detail/:rollcallId', component: require('./views/rollcall/rollcallDetail.vue') },
    { path: '/rollcall/hand/:rollcallId', component: require('./views/rollcall/rollcallHand.vue') },
    // 广告详情
    { path: '/ad/info/:adId', component: require('./views/ad/AdInfo.vue') },
    // 活动详情
    { path: '/activity/info/:activityId', component: require('./views/activity/ActivityInfo.vue') },
    //  // 选择角色
    { path: '/chooseRole', component: require('./views/ChooseRole.vue') },
     // 保险
    { path: '/insurance/insurance', component: require('./views/insurance/Insurance.vue') },
    // PDF电子保单
    { path: '/insurance/insurance-pdf/:pdfUrl', component: require('./views/insurance/InsurancePdf.vue') },
    // 动态
    { path: '/dynamic/publish/:dynamicTypeId', component: require('./views/dynamic/DynamicPublish.vue') },
    { path: '/dynamic/list/:dynamicTypeId', component: require('./views/dynamic/DynamicList.vue') },
    // 成绩
    { path: '/score/publish', component: require('./views/score/scorePublish.vue') },
    { path: '/score/list/:studentId', component: require('./views/score/scoreList.vue') },
    // 身高体重
    { path: '/heightAndWeight/publish', component: require('./views/heightAndWeight/HeightAndWeightPublish.vue') },
    { path: '/heightAndWeight/list/:studentId', component: require('./views/heightAndWeight/HeightAndWeightList.vue') },
    // 资料
    { path: '/information/list', component: require('./views/information/InformationList.vue') },
    { path: '/information/detail/:detailId', component: require('./views/information/InformationDetail.vue') },
    { path: '/invitation/parents', component: require('./views/invitation/parents.vue') },
    { path: '/invitation/teacher', component: require('./views/invitation/teacher.vue') },
    { path: '/networkLess', component: require('./views/networkLess.vue') },
    /** 提醒家长接送 **/
    // 提醒列表
    { path: '/remind/list', component: require('./views/remind/remindList.vue') },
    // 提醒设置
    { path: '/remind/edit/:curcheHandsTimeId', component: require('./views/remind/remindEdit.vue') },
    // 提醒添加
    { path: '/remind/add', component: require('./views/remind/remindAdd.vue') },
    { path: '*', redirect: '/signin' }
]
  // router.beforeEach((to, from, next) => {
  //   Indicator.close()
  //   $('body').css('overflow', 'auto')
  //   next()
  // })
  // router.redirect({ path: '*', redirect: '/signin'})
// }



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/router.js